module.exports = __webpack_public_path__ + "assets/b8362255cd6b018a0b2f661a735219e8.png";